import { render, staticRenderFns } from "./NhAboutPage.vue?vue&type=template&id=8f19159e"
import script from "./NhAboutPage.vue?vue&type=script&lang=js"
export * from "./NhAboutPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports